import { ExamEventResponse, ExaminersClient, ExamSubjectsClient } from "../../../generated-client/generated-api-client";
import { DateTime } from "luxon";
import { DateFormatter, DateFormatType } from "../../../utils/dateFormatter";

export class ExamEventModel {

  constructor(private eventResponse: ExamEventResponse, private examinerClient: ExaminersClient, private examSubjectClient: ExamSubjectsClient) {

    this.entryCreated = eventResponse.entryCreated == null ? "" : this.dateToString(eventResponse.entryCreated);
    this.eventStart = eventResponse.eventStart == null ? "" : this.dateToString(eventResponse.eventStart);
    this.entryDescription = eventResponse.entryDescription == null ? "" : eventResponse.entryDescription;
    this.eventEntryCategory = eventResponse.eventEntryCategory == null ? "" : eventResponse.eventEntryCategory;
    this.courseName = "Nincs aktív kurzus";
    if (eventResponse.courseExternalId != null && eventResponse.courseExternalId != "")
      examSubjectClient.get(eventResponse.courseExternalId).subscribe(x => { this.courseName = x.subjectName ?? ""; console.log(x) });
    this.systemMessage = eventResponse.systemMessage == null ? "" : eventResponse.systemMessage;
    this.eventCreator = "Vizsgázó";
    if (eventResponse.externalIdpUserId != null)
      examinerClient.info(eventResponse.externalIdpUserId).subscribe(x => this.eventCreator = x.email ?? "Ismeretlen Vizsgabiztos");
  }

  dateToString(date: DateTime): string {
    return DateFormatter.format(date.toString(), DateFormatType.DateTime);
  }

  /** Bejegyzés időpontja */
  entryCreated: string;
  /** Bejegyzés információ */
  entryDescription: string;
  /** Bejegyzés kategória */
  eventEntryCategory: string;
  /** Esemény időpontja */
  eventStart: string;
  /** Kurzus azonosító (saját) */
  courseName: string;
  /** Bejegyzes rendszer üzenet */
  systemMessage: string;
  /** vizsgabiztos azonosító */
  eventCreator: string;
}
